// user-dashboard/components/TrafficLight.jsx
import React from "react";

/**
 * Traffic light indicator for port status
 *
 * Props:
 * - status: one of 'active', 'activating', 'queued', 'error', 'inactive'
 * - animate: if true, apply pulsing animation (used for 'activating')
 */
export default function TrafficLight({ status, animate = false }) {
  const colorFor = (s) => {
    switch (s) {
      case "active":
        return "#28a745"; // green
      case "activating":
        return "#ffc107"; // yellow (warmup)
      case "queued":
        return "#ffc107"; // yellow (no animation)
      case "error":
        return "#dc3545"; // red
      default:
        return "#6c757d"; // gray (inactive/unknown)
    }
  };

  const color = colorFor(status);
  const showGlow = status !== "inactive";

  return (
    <>
      {/* Local keyframes for pulse animation (scoped by React) */}
      <style>
        {`
          @keyframes pulse {
            0% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.15); opacity: 0.8; }
            100% { transform: scale(1); opacity: 1; }
          }
        `}
      </style>

      <span
        role="img"
        aria-label={`status-${status}`}
        className="rounded-circle me-2"
        style={{
          display: "inline-block",
          width: "12px",
          height: "12px",
          backgroundColor: color,
          border: "1px solid rgba(0,0,0,0.1)",
          borderRadius: "50%",
          animation: animate ? "pulse 1.5s ease-in-out infinite" : "none",
          boxShadow: showGlow ? `0 0 8px ${color}40` : "none",
        }}
        title={status}
      />
    </>
  );
}
